import { render } from "./UEContingentEditView.vue?vue&type=template&id=bf884438&scoped=true"
import script from "./UEContingentEditView.vue?vue&type=script&lang=js"
export * from "./UEContingentEditView.vue?vue&type=script&lang=js"

import "./UEContingentEditView.vue?vue&type=style&index=0&id=bf884438&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf884438"]])

export default __exports__